import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import cellEditFactory from "react-bootstrap-table2-editor";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../helpers/units";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import SweetAlert from "react-bootstrap-sweetalert";

const animatedComponents = makeAnimated();

const AllDrafts = (props) => {
  const [itemsForOrder, setItemsForOrder] = useState([]);
  const [isUrgent, setIsUrgent] = useState(false)
  const { SearchBar } = Search;

  useEffect(() => {
    loadAllOrders();
    loadAllItems();
  }, []);

  const [remarks, setRemarks] = useState();


  const [allOrders, setAllOrders] = useState([]);
  const [confirmClose, setConfirmClose] = useState(false);
  const loadAllOrders = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "itemorderdrafts/getall";
    const response = await postSubmitForm(url, {  });
    if (response && response.status === 1) {
      preloader(false);
      setAllOrders(response.data);
      // setExpanded(expandedRows);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const details_columns = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      text: props.t("Available"),
      dataField: "available",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available,row.unit_levels)             
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "arrangement_quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.arrangement_quantity)             
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
  ];
  const [selectedOrder, setSelectedOrder] = useState();
  const [editModal, setEditModal] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      dataField: "draft_id",
      text: props.t("Draft ID"),
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
 
    {
      text: props.t("Order Date"),
      dataField: "createdAt",
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
    },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      text: props.t("Details"),
      csvExport: false,
      formatter: (cell, row) => {
          return (
            <span className="text-info">
              <i
                className="mdi mdi-text-box-search font-size-15"
                title="Click to View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDetailsModal(!detailsModal);
                  setSelectedOrder(row);
                  }}
              ></i>
            </span>
          );
      },
    },
    {
      dataField: "",
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport: false,
      formatter: (cell, row) => {
       
          return (
            <>
            <span className="text-info" style={{marginRight:"15px"}}>
              <i
                className="bx bxs-edit font-size-15"
                title="Click to Edit"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditModal(!editModal);
                  setItemsForOrder(row.item_details)
                  setSelectedOrder(row);
                  setIsUrgent(row.is_urgent)
                  setRemarks(row.remarks);
                }}
              ></i>
            </span>
           <span className="text-danger">
           <i
                className="bx bxs-trash font-size-15"
                title="Click to Delete"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setConfirmClose(!editModal);
                  setSelectedOrder(row);
                }}
              ></i>
           </span>
            </>
          );
      },
    },
  ];

  const [detailsModal, setDetailsModal] = useState(false);
  const refForForm = useRef(null);
  const refSelectItem = useRef(null);
  const [allItems, setAllItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchitems/getforbranch";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || [];
      setAllItems(filtered);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [isDisabled, setIsDisabled] = useState(false)
  const [isDraftSubmitting, setIsDraftSubmitting] = useState(false)
  const handleSubmit = async (e, v,is_darft) => {
    try {
      let url = "";
      const payload = {
        id: selectedOrder._id,
        item_details: itemsForOrder,
        is_urgent: isUrgent,
        remarks: remarks,
      };
      if(is_darft){
        url = process.env.REACT_APP_BASEURL +  "itemorderdrafts/update";
        setIsDraftSubmitting(true)
      }else{
        Object.assign(payload,{itemorderdraft_id:selectedOrder._id,})
        url = process.env.REACT_APP_BASEURL +  "itemorders/insert";
        setIsDisabled(true)
      }
      let response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        loadAllOrders();
        setIsUrgent(false)
        setEditModal(!editModal);
        setRemarks();
        setItemsForOrder([]);
        setSelectedItem();
        refSelectItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
        refForForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally{
      setIsDraftSubmitting(false)
      setIsDisabled(false)
    }
  };
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (item) => item.item_id !== row.item_id
              );

              setItemsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns_items = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      text: props.t("From Supplier"),
      dataField: "direct_po",
      formatter:(cell,row)=>{
        return row.direct_po ? "Yes" : "No"
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Branch Avl. Qty."),
      formatter: (cell, row) => {
       return formatUnitsForReport(row.available,row.unit_levels)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: itemsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];
 
  const handleDownload = async () => {
    const fileName = "all_draft_orders";
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Draft_ID: v.draft_id,
          Remarks: v.remarks,
          Order_Date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
          // IsUrgent: v.is_urgent ? "Yes" : "No",
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleDeleteDraft = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemorderdrafts/delete";
    const response = await postSubmitForm(url, {
      id: selectedOrder._id,
    });
    if (response && response.status === 1) {
      loadAllOrders();
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  function handleAddQuantity(e,v) {
    e.preventDefault()
    let arrangement_quantity = [{unit:selectedItem.unit_for_max_order, value:Number(v.arrangement_quantity)}]
      let maxLimit = convertToLowestUnit(selectedItem.unit_levels,[{unit:selectedItem.unit_for_max_order,value:selectedItem.max_order_limit}]);
      let totalEntered =   convertToLowestUnit(selectedItem.unit_levels,arrangement_quantity)
      if(totalEntered>maxLimit){
        showNotification(`can not add more than <strong> ${selectedItem.max_order_limit+" "+selectedItem.unit_for_max_order} </strong>`,"Warning")
        return
      }
   let convertedQuantity = GetUpdatedDelivered(arrangement_quantity,selectedItem.unit_levels)
    var new_array_items = JSON.parse(JSON.stringify(itemsForOrder));
    const existing_item = new_array_items.filter(function (item) {
      return item.item_id === selectedItem.item_id;
    });

    if (existing_item.length > 0) {
      showNotification(props.t("This item is already added."),props.t("Warning"));
    } else if (selectedItem) {
      let item_to_add = {};
      item_to_add.item_id = selectedItem?.item_id;
      item_to_add.name = selectedItem.name;
      item_to_add.category = selectedItem.category;
      item_to_add.sub_category = selectedItem.sub_category;
      item_to_add.arrangement_quantity = arrangement_quantity;
      item_to_add.available = selectedItem.available.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.initial_order_quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedItem.unit_levels;
      item_to_add.unit_for_po = selectedItem.unit_for_po;
      item_to_add.direct_po = selectedItem.direct_po;
      item_to_add.unit_for_max_order = selectedItem.unit_for_max_order;
      item_to_add.expiry_date = selectedItem.expiry_date;
      if(selectedItem.max_order_limit>0){
        item_to_add.max_order_limit = selectedItem.max_order_limit;
      }
      item_to_add.cost_price = selectedItem.cost_price;
      item_to_add.selling_price = selectedItem.selling_price;
      setItemsForOrder([...itemsForOrder, item_to_add]);
      setSelectedItem();
      refSelectItem.current.select.clearValue();
      refForForm.current.reset();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("All Draft Orders")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4" md='4'>
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("All Draft's")}
                    </CardTitle>

                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns_external}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                          
                          </Row>

                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Edit Modal starts */}
      <Modal
        size="xl"
        isOpen={editModal}
        toggle={() => setEditModal(!editModal)}
        onClosed={() => {setSelectedItem();
        }}
      >
        <ModalHeader toggle={() => setEditModal(!editModal)}>
          {props.t("Order Details -")} <strong>{selectedOrder?.draft_id}</strong>
        </ModalHeader>
        <ModalBody>
          {selectedOrder && (
            <>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <AvForm
                        onValidSubmit={handleAddQuantity}
                        ref={refForForm}
                      >
                        <Row>
                          <Col lg={4}>
                            <Label>{props.t("Item")}</Label>
                            <Select
                              ref={refSelectItem}
                              value={selectedItem}
                              onChange={(selected) => {
                                setSelectedItem(selected);
                                refForForm.current.reset();
                              }}
                              options={allItems}
                              classNamePrefix="select2-selection"
                              components={animatedComponents}
                              required
                            />
                          </Col>
                          {selectedItem && (
            <>
              <Col lg={2}>
                <br />
                <Label>Available </Label>
                <br />
                <Label>
                  {formatUnitsForReport(selectedItem.available,selectedItem?.unit_levels)}
                </Label>
              </Col>
              <Col lg={2}>
                <br />
                <Label>Threshold Quantity</Label>
                <br />
                <Label>
                  {selectedItem.threshold +
                    " " +
                    selectedItem.unit_for_threshold}
                </Label>
              </Col>
              <Col lg={2}>
                              <Label>
                                {props.t("Qty.")} in {`${selectedItem.unit_for_max_order}`}
                              </Label>

                              <AvField
                                name="arrangement_quantity"
                                placeholder={props.t("Enter Quantity")}
                                type="number"
                                min="0"
                                step="1"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Quantity cannot be empty.",
                                  },
                                  pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: props.t(
                                      "Only numbers are allowed."
                                    ),
                                  },
                                  max: {
                                    value:selectedItem && selectedItem.max_order_limit,
                                    errorMessage: selectedItem &&
                                      props.t("Cannot enter more than ") +
                                      selectedItem.max_order_limit +" " +selectedItem.unit_for_max_order +".",
                                  },
                                }}
                              />
                            </Col>
            </>
          )}

                          <Col lg={2} className="mb-4">
                            <Label>&nbsp;</Label>
                            <br />
                            <Button
                              type="submit"
                              color="primary"
                              className="btn btn-info waves-effect waves-light btn-sm"
                            >
                              <i class="bx bx-add-to-queue"></i>{" "}
                              {props.t("Add")}
                            </Button>
                          </Col>
                        </Row>
                        {/* <Button type="submit">Submit</Button> */}
                      </AvForm>
                      <hr />
                      {itemsForOrder && itemsForOrder.length > 0 && (
                        <>
                          <BootstrapTable
                            bootstrap4
                            keyField="_id"
                            data={itemsForOrder && itemsForOrder}
                            columns={columns_items}
                            noDataIndication="No data to display."
                            striped
                            hover
                            condensed
                          />
                          <AvForm>
                            <Row>
                              <Col lg={6}>
                                <AvField
                                  name="remarks"
                                  value={remarks}
                                  onChange={(e) => {
                                    setRemarks(e.target.value);
                                  }}
                                  label={props.t("Remarks")}
                                  placeholder={props.t("Enter Remarks")}
                                  type="textarea"
                                />
                              </Col>
                              <Col lg={12}>
                              <div class="form-check">
                              <input
                                type="checkbox"
                                name="is_urgent"
                                id="isUrgentCheckbox"
                                className="is-untouched is-pristine av-valid form-check-input"
                                checked={isUrgent}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setIsUrgent(true);
                                  } else {
                                    setIsUrgent(false);
                                  }
                                }}
                              />
                              <label for="isUrgentCheckbox">
                                {props.t("This is an urgent order.")}
                              </label>
                            </div>
                                          </Col>
                              <Col lg={12}>
                                <hr />
                                <FormGroup className="mb-0 text-left">
                                  <div>
                                  <Button
                                  type="submit"
                                  className="mr-3"
                                  color="primary"
                                  onClick={(e,v)=>handleSubmit(e,v,false)}
                                  style={{width:"180px"}}
                                  disabled={isDraftSubmitting || isDisabled}
                                >
                          {isDisabled? <Spinner size="sm" /> : props.t("Place Order")} 
                                </Button>
                                    <Button
                                      type="submit"
                                      color="secondary"
                                      onClick={(e,v)=>handleSubmit(e,v,true)}
                                      style={{width:"160px"}}
                                      disabled={isDisabled || isDraftSubmitting}
                              
                                    >
                                         {isDraftSubmitting ? <Spinner size="sm" /> :"Update Draft"}
                                    </Button>
                                    
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AvForm>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>

      {/* Edit Modal ends */}

      {/* Details Modal starts */}
      <Modal
        size="xl"
        isOpen={detailsModal}
        toggle={() => setDetailsModal(!detailsModal)}
        style={{ width: "1200px", minWidth: "1200px" }}
      >
        <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
          {props.t("Order Details")}
        </ModalHeader>
        <ModalBody>
          <>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row>

                      <Col lg={12} md={12}>
                        <Label>Ordered Items</Label>
                      </Col>

                      <Col lg={12}>
                        <BootstrapTable
                          bootstrap4
                          keyField="_id"
                          data={selectedOrder && selectedOrder.item_details}
                          columns={details_columns}
                          noDataIndication="No data to display."
                          striped
                          hover
                          condensed
                        />
                        <hr />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        </ModalBody>
      </Modal>
      {/* Details Modal ends */}
  {/* ---Close Reamarks Modal Start--- */}
                  {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleDeleteDraft();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t("Once you delete this darft, it cannot be revoked.")}
                    </SweetAlert>
                  )}
   
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(AllDrafts)));
